let base_url_assets = "https://www.diazappsnfts.com"
/* let base_url_assets = "" */



export default base_url_assets